/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-27 08:00:00
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import { connect } from 'react-redux';
import { Button, Tooltip, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import React, {useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { allowToShowBFCM22 } from 'src/helpers/dashboard-helper';
import partnerVajro from 'src/assets/images/campaigns/partner-vajro.png';
import partnerGempages from 'src/assets/images/campaigns/partner-gempages.png';
import partnerGrowave from 'src/assets/images/campaigns/partner-growave.png';
import partnerLangify from 'src/assets/images/campaigns/partner-langify.png';
import starIcon from 'src/assets/images/campaigns/star-icon.png';
import copyIcon from 'src/assets/images/campaigns/copy.png';
import helpIcon from 'src/assets/images/campaigns/help.svg';
import './bfcm2022.css';

type Props = {
  name: string,
  welcome: Object
};

type ComposedProps = Props & WithI18nProps;

const BFCM2022PartnerItem: React.FC<ComposedProps> = ({
  id,
  srcLogo,
  partner,
  detail,
  rating,
  off,
  code,
  date,
  link,
  note,
  i18n
}) => {

  const [isCopied, setIsCopied] = useState(false);
  const onClickCopyCoupon = (text) => {
    const copyText = document.getElementById(`${id}-${code}`);
    copyText.select();       
    copyText.setSelectionRange(0, 10);
    try {
      navigator.permissions.query({ name: 'clipboard-write' }).then(function (result) {
        if (result.state === 'granted') {
          navigator.clipboard.writeText(text);
        } else {
          document.execCommand("copy");
        }
      });
    } catch (error) {}
    setIsCopied(true);
  }

  useEffect(() => {
    let copied = setTimeout(() => setIsCopied(false), 2000);
    return () => {
      clearTimeout(copied);
    };
  }, [isCopied]);

  return (
    <div className="bfcm2022_partner_list_item">
      <div className="item wrapper">
        <div className="top">
          <img className="partner" src={srcLogo} alt="" />
          <div>
            <div className="text_partner">{partner}</div>
            <div className="text_detail">{detail}</div>
            <div className="text_rating"><img src={starIcon} alt="star" className="star"/><span>{rating}</span></div>
          </div>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="left-content">
              <div className="off">{off}</div>
              <div className="date">{date}</div>
            </div>
          </div>
          <div className="right">
            <div className="right-content">
              <div className="code-text">
                <span className={`copied ${isCopied || 'hide'}`}>Copied!</span>
                {
                  code ?
                  <div>
                    <span>Code: </span>
                    <span onClick={() => onClickCopyCoupon(code)} className="code">{code}</span>
                    <textarea readOnly className="copytext" id={`${id}-${code}`} value={code}></textarea>
                    <img onClick={() => onClickCopyCoupon(code)} className="copy" src={copyIcon} alt="" />
                  </div> : 
                  <Tooltip preferredPosition="above" content={<div style={{ width: '200px'}} className="help-tooltip">{note}</div>}>
                    <div className="help">
                      <TextStyle>Tip for you </TextStyle>
                      <img style={{ marginLeft: '4px'}} src={helpIcon} alt='help' />
                    </div>
                  </Tooltip>
                }
              </div>
              <div className="code-btn">
                <Button 
                  primary 
                  size="large" 
                  onClick={() => {
                    window.open(link, '_blank', 'noopener,noreferrer');
                  }}
                >
                  {i18n.translate(`AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_get_deal_btn`)}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}
const BFCM2022PartnerList: React.FC<ComposedProps> = ({
  tenantApp,
  themesLoading,
  i18n,
  isAllowBFCM2022
}) => {
  const location = useLocation();
  const dataPartners = [
    {
      id: 1,
      srcLogo: partnerVajro,
      partner: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_partner'),
      detail: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_detail'),
      rating: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_rating'),
      off: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_off'),
      code: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_code'),
      date: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_date'),
      link: 'https://apps.shopify.com/vajro?&utm_source=inapp&utm_medium=notification&utm_campaign=bfcm22',
      note: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_vajro_note')
    },
    {
      id: 2,
      srcLogo: partnerLangify,
      partner: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_partner'),
      detail: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_detail'),
      rating: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_rating'),
      off: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_off'),
      code: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_code'),
      date: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_date'),
      link: 'https://api.langify-app.com/discount/partner/dfd01b31ba7eaea5ca45c6be2a7d6dff?utm_source=Boost+Commerce&utm_medium=Boost+commerce&utm_campaign=BFCM+Campaign+',
      note: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_langify_note')
    },
    {
      id: 3,
      srcLogo: partnerGempages,
      partner: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_partner'),
      detail: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_detail'),
      rating: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_rating'),
      off: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_off'),
      code: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_code'),
      date: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_date'),
      link: 'https://app.gempages.net/install/?&utm_source=inapp&utm_medium=notification&utm_campaign=bfcm22',
      note: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_gempages_note')
    },
    {
      id: 4,
      srcLogo: partnerGrowave,
      partner: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_partner'),
      detail: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_detail'),
      rating: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_rating'),
      off: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_off'),
      code: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_code'),
      date: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_date'),
      link: 'https://growave.io/?discount_code=20%offBoostC',
      note: i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_growave_note')
    }
  ]

  return (
    <div>
      {
        isAllowBFCM2022 && location.pathname === '/plan-discount' && 
        <div className="bfcm2022_partner">
          <div className="title">
            <div>{i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_text1')}</div>
            <div>{i18n.translate('AdminHTML.Common.ShopifyEmbeddedAppRoute.BFCM2022_Partner_text2')}</div>
          </div>
          <div className="bfcm2022_partner_list">
            {
              dataPartners.map((partner, index) => {
                return (
                  <BFCM2022PartnerItem
                    key={index}
                    id={partner.id}
                    srcLogo={partner.srcLogo}
                    partner={partner.partner}
                    detail={partner.detail}
                    rating={partner.rating}
                    off={partner.off}
                    code={partner.code}
                    date={partner.date}
                    link={partner.link}
                    note={partner.note}
                    i18n={i18n}
                  />
                )
              })
            }
          </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state, props) => {
  const externalInfo = _.get(state.oauth.tenantApp, 'externalInfo', {});
  const welcome = _.get(state.dashboard, 'dashboardComponents.welcomes.data', {});
  const isAllowBFCM2022 = allowToShowBFCM22(state.oauth.tenantApp);

  return {
    name: _.get(externalInfo, 'name', ''),
    welcome,
    isAllowBFCM2022
  };
};

export default connect(mapStateToProps)(withI18n()(BFCM2022PartnerList));
